export default function setupAxios(axios, store) {
  // 只需在create instance後執行一次就可以了
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();
      console.log(authToken)
      return config;
    },
    (err) => {
      console.log("err");
      Promise.reject(err);
    }
  );
}
